'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
type ChangeSubscriptionFlowProps = {
  isPending: boolean;
  onOpenConfirm: () => void;
};
export function ChangeSubscriptionFlow(t0) {
  const $ = _c(3);
  const {
    isPending,
    onOpenConfirm
  } = t0;
  let t1;
  if ($[0] !== isPending || $[1] !== onOpenConfirm) {
    t1 = <Button size="xl" type="button" className="w-full" onClick={onOpenConfirm} loading={isPending}>Sprawdź i zapisz zmianę</Button>;
    $[0] = isPending;
    $[1] = onOpenConfirm;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}